import React from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";


const TOOLTIP_ZINDEX = 99999;

export function TooltipWrap({
    enabled,
    title,
    children,
    display = "inline-flex",
    placement = "top",
    sx,
}: {
    enabled: boolean;
    title: string;
    children: React.ReactNode;
    display?: "inline-flex" | "block";
    placement?: "bottom" | "top" | "left" | "right" | "bottom-start" | "bottom-end" | "top-start" | "top-end" | "left-start" | "left-end" | "right-start" | "right-end";
    sx?: any;
}) {
    if (!enabled) return <>{children}</>;

    return (
        <Tooltip
            title={title}
            arrow
            placement={placement}
            disableInteractive={false}
            PopperProps={{
                disablePortal: false,
                modifiers: [
                    { name: "preventOverflow", options: { boundary: "viewport" } },
                    { name: "flip", options: { altBoundary: true } },
                ],
            }}
            componentsProps={{
                popper: {
                    sx: { zIndex: TOOLTIP_ZINDEX },
                },
            }}
        >
            <Box component="span" sx={{ display, ...sx }}>
                {children}
            </Box>
        </Tooltip>
    );
}

export function DisabledCloneWrap({
    child,
    sx,
}: {
    child: React.ReactElement;
    sx?: any;
}) {
    const cloned = React.cloneElement(child, {
        disabled: true,
        "aria-disabled": true,
        onClick: undefined,
        onMouseDown: undefined,
        onKeyDown: undefined,
        onChange: undefined,
    });

    return <Box sx={{ display: "inline-flex", ...sx }}>{cloned}</Box>;
}

export function OverlayWrap({
    children,
    label,
    overlay,
    sx,
    overlaySx,
    action,
}: {
    children: React.ReactNode;
    label?: string;
    overlay: boolean;
    sx?: any;
    overlaySx?: any;
    action?: React.ReactNode;
}) {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                pointerEvents: "none",
                userSelect: "none",
                ...sx,
            }}
        >
            <Box sx={{ opacity: 0.6 }}>
                {children}
            </Box>

            {overlay && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                        backdropFilter: "blur(4px)",
                        bgcolor: "rgba(var(--fx-surface-basergb, 255, 255, 255), 0.2)",
                        ...overlaySx,
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5, pointerEvents: "auto" }}>
                        {label ? (
                            <Box sx={{ px: 1.5, py: 0.75, bgcolor: "rgba(0,0,0,0.7)", borderRadius: 1 }}>
                                <Typography variant="caption" sx={{ color: "#fff", fontWeight: 700 }}>
                                    {label}
                                </Typography>
                            </Box>
                        ) : null}
                        {action}
                    </Box>
                </Box>
            )}
        </Box>
    );
}
